/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterscurrency
 */
import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Currency" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersCurrency ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersCurrency extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Currency', [
            {
                character: '$',
                title: t('dd')
            },
            {
                character: '\u20AC',
                title: t('de')
            },
            {
                character: '\xA5',
                title: t('df')
            },
            {
                character: '\xA3',
                title: t('dg')
            },
            {
                character: '\xA2',
                title: t('dh')
            },
            {
                character: '\u20A0',
                title: t('di')
            },
            {
                character: '\u20A1',
                title: t('dj')
            },
            {
                character: '\u20A2',
                title: t('dk')
            },
            {
                character: '\u20A3',
                title: t('dl')
            },
            {
                character: '\u20A4',
                title: t('dm')
            },
            {
                character: '\xA4',
                title: t('dn')
            },
            {
                character: '\u20BF',
                title: t('do')
            },
            {
                character: '\u20A5',
                title: t('dp')
            },
            {
                character: '\u20A6',
                title: t('dq')
            },
            {
                character: '\u20A7',
                title: t('dr')
            },
            {
                character: '\u20A8',
                title: t('ds')
            },
            {
                character: '\u20A9',
                title: t('dt')
            },
            {
                character: '\u20AA',
                title: t('du')
            },
            {
                character: '\u20AB',
                title: t('dv')
            },
            {
                character: '\u20AD',
                title: t('dw')
            },
            {
                character: '\u20AE',
                title: t('dx')
            },
            {
                character: '\u20AF',
                title: t('dy')
            },
            {
                character: '\u20B0',
                title: t('dz')
            },
            {
                character: '\u20B1',
                title: t('ea')
            },
            {
                character: '\u20B2',
                title: t('eb')
            },
            {
                character: '\u20B3',
                title: t('ec')
            },
            {
                character: '\u20B4',
                title: t('ed')
            },
            {
                character: '\u20B5',
                title: t('ee')
            },
            {
                character: '\u20B6',
                title: t('ef')
            },
            {
                character: '\u20B7',
                title: t('eg')
            },
            {
                character: '\u20B8',
                title: t('eh')
            },
            {
                character: '\u20B9',
                title: t('ei')
            },
            {
                character: '\u20BA',
                title: t('ej')
            },
            {
                character: '\u20BB',
                title: t('ek')
            },
            {
                character: '\u20BC',
                title: t('el')
            },
            {
                character: '\u20BD',
                title: t('em')
            }
        ]);
    }
}